import { Container } from "@mui/material";
import Page from "src/components/Page";
import PageHeader from "src/components/PageHeader";
import useLocales from "src/hooks/useLocales";
import useTabs from "src/hooks/useTabs";

import OrgSettingsTab from "./OrgSettingsTab";
import OrgUsers from "./OrgUsers/OrgUsers";

// ----------------------------------------------------------------------

export const OrganizationSettings = () => {
	const { currentTab, onChangeTab } = useTabs("users");
	const { translate } = useLocales();

	return (
		<Page title={translate("organization.title")}>
			<Container maxWidth={"xl"}>
				<PageHeader title={translate("organization.title")} back={false} />
				<OrgSettingsTab onChangeTab={onChangeTab} currentTab={currentTab} />
				{currentTab === "settings" && <div />}
				{currentTab === "users" && <OrgUsers />}
			</Container>
		</Page>
	);
};

export default OrganizationSettings;
